import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.esm.browser.min.js'

class FeaturedListCarrousel extends HTMLElement {
  constructor(){
    super();
    this.prevArrow = this.querySelector('.swiper-button-prev')
    this.nextArrow = this.querySelector('.swiper-button-next')
    this.sliderQuantity = this.dataset.slides || 3
    this.isDraggable = this.dataset.dragable === "true" ? true : false 

    const swiper = new Swiper('#collection-slider--carousel', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 15,
      allowTouchMove: this.isDraggable,
      breakpoints: {
        700: {
          slidesPerView: 2,
          spaceBetween: 30,
          allowTouchMove: true,
        },
        1000: {
          slidesPerView: this.sliderQuantity,
          spaceBetween: 30,
          allowTouchMove: true,
        }
      },
      // Navigation arrows
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

window.customElements.define("featured-list-carrousel", FeaturedListCarrousel)